/*
 * Gift buttons on the free booklets (snippets/booklet-gift.liquid, 2026-10-08).
 * The buttons are drawn hidden at the end of the page (layout/theme.liquid) and
 * moved here just above the booklet's add-to-cart.
 * After the theme adds a booklet to the cart, the "Sponsor Booklets" line is
 * set to the gift picked on that booklet's buttons: quantity 1, any other gift
 * amount removed, so a cart holds one gift per order whatever the number of
 * books. "No gift" changes nothing. Then the cart drawer is told, the way the
 * theme tells it.
 */
(function () {
  if (window.__bookletGift) return;
  window.__bookletGift = true;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  }

  async function setGift(variantId, giftIds) {
    var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    var updates = {};
    var already = false;
    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id);
      if (giftIds.indexOf(id) === -1) return;
      if (id === variantId && item.quantity === 1 && !already) { already = true; return; }
      updates[id] = 0;
    });
    if (!already) updates[variantId] = 1;
    if (Object.keys(updates).length === 0) return;
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionIds() })
    });
    var updated = await res.json();
    if (updated.status) return;
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: updated,
      sourceId: 'booklet-gift',
      data: { source: 'booklet-gift', itemCount: updated.item_count, sections: updated.sections }
    };
    document.dispatchEvent(ev);
  }

  // Put the buttons just above the booklet's add-to-cart and show them.
  function place() {
    document.querySelectorAll('fieldset.booklet-gift[hidden]').forEach(function (box) {
      var form = document.querySelector('product-form-component[data-product-id="' + box.dataset.productId + '"]');
      if (!form || !form.parentNode) return;
      form.parentNode.insertBefore(box, form);
      box.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();

  document.addEventListener('cart:update', function (event) {
    var d = event.detail && event.detail.data;
    if (!d || d.source !== 'product-form-component' || d.didError) return;
    var boxes = document.querySelectorAll('.booklet-gift[data-product-id="' + String(d.productId) + '"]');
    var box = boxes[boxes.length - 1];
    if (!box) return;
    var picked = box.querySelector('input[type="radio"]:checked');
    var variantId = picked ? picked.value : '';
    if (!variantId) return;
    var giftIds = (box.dataset.giftVariants || '').split(',').filter(Boolean);
    setGift(variantId, giftIds).catch(function (e) { console.error('booklet gift', e); });
  });
})();
